;(function(){

	window.dataLayer = window.dataLayer || [];

	if (site.width < 768) {
		return;
	}

	var
		block    = 'search',
		$block   = $(bem.selector(block)),
		products = new Bloodhound({
			identify: function(product) {
				return product.id;
			},
			datumTokenizer: function(product) {
				return Bloodhound.tokenizers.whitespace(product.name);
			},
			queryTokenizer: Bloodhound.tokenizers.whitespace,
			remote: {
				url: '/api/product/search?term=%QUERY',
				wildcard : '%QUERY'
			}
			/*prefetch: {
				url: 'http://www.mocky.io/v2/5773a3610f0000660c597ab6',
				cache: false
			}*/
		});

	$('#site-search')
		.on('submit', function(e){
			dataLayer.push({
				'eventCategory': 'Site Search',
				'eventLabel': $(this).find('input[name="search"]').val(),
				'eventAction': 'submit',
				'event': 'gaEvent'
			});
		});

	$block.find(bem.selector(block, 'input'))
		.typeahead(
			{
				hint: false,
				highlight: true,
				minLength: 3,
				classNames: {
					wrapper: 'search__typeahead',
					menu: 'search__results',
					dataset: 'search__data',
					cursor: bem.states.active
				}
			},
			{
				source: products,
				limit: 3,
				templates: {
					footer: '<button class="a h5 search__more" type="submit">View all results</button>',
					suggestion: function(product) {
						return [

							'<a class="a--subtle search__result" href="' + product.url + '">',
								'<img class="placeholder__img search__result-img" src="' + product.img + '">',
								'<p class="h5 regular search__result-name">',
									product.name,
									'<span class="search__result-price">' + product.price + '</span>',
								'</p>',
							'</a>',

						].join('');
					}
				},
				display: function(product) {
					return product.name;
				}
			}
		)
		.on('typeahead:active typeahead:idle', function(e) {

			$block.toggleClass(bem.states.focus, e.type === 'typeahead:active');

		})
		.on('typeahead:open typeahead:close', function(e, isEmpty) {

			$block.toggleClass(bem.states.active, e.type === 'typeahead:open' && !isEmpty);

		})
		.on('typeahead:querychanged', function(e, isEmpty) {

			$block.toggleClass(bem.states.active, !isEmpty);

		})
		.on('typeahead:render', function(e, suggestions) {

			$block.toggleClass(bem.states.active, !!suggestions);

		})
		.on('typeahead:select', function(e, product) {

			dataLayer.push({
				'eventCategory': 'Site Search - Typeahead Select',
				'eventLabel': product.name,
				'eventAction': 'select',
				'event': 'gaEvent'
			});

			$(document.activeElement).trigger('blur');
			window.location.href = product.url;

		});

}());
